import React from 'react';
import PropTypes from 'prop-types';
import './lineAllocations.scss';
import ArrowExpandButton from '../arrowExpandButton/ArrowExpandButton';

class LineAllocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.invoiceDetail.allocationJurisdictions.length !== 1
    };
  }

  handleExpand = () => this.setState({ collapsed: false });

  handleCollapse = () => this.setState({ collapsed: true });

  render() {
    const {
      totalTaxRate,
      totalTaxAmount,
      allocationJurisdictions
    } = this.props.invoiceDetail;
    const { collapsed } = this.state;
    return (
      <div>
        <div className="line-allocations__columns-row">
          {
            allocationJurisdictions.length &&
            <div className="line-allocations__arrow-expander">
              <ArrowExpandButton
                collapsed={ collapsed }
                onExpand={ this.handleExpand }
                onCollapse={ this.handleCollapse }
              />
            </div>
          }
          <div className="line-allocations__grid-container">
            <div className="line-allocations__columns-row">
              <div className="line-allocations__column">Cost Object</div>
              <div className="line-allocations__column_fixed-small">Count</div>
              <div className="line-allocations__column_fixed-small">Amount</div>
            </div>
          </div>
          <div className="line-allocations-jurisdiction__grid-container">
            <div className="line-allocations-jurisdiction__columns-row">
              <div className="line-allocations-jurisdiction__column">Jurisdiction</div>
              <div className="line-allocations-jurisdiction__column_fixed-small">Total Rate</div>
              <div className="line-allocations-jurisdiction__column_fixed-small">Taxable</div>
              <div className="line-allocations-jurisdiction__column_fixed-small">Exempt</div>
              <div className="line-allocations-jurisdiction__column_fixed-small">Tax Amount</div>
            </div>
          </div>
        </div>
        {
          allocationJurisdictions.map( allocationJurisdiction => (
            <div key={ allocationJurisdiction.costObjectName }>
              <div  className="line-allocations__container">
                <div className="line-allocations__grid-container">
                  <div className="line-allocations__row">
                    <div className="line-allocations__column line-allocations__column_bold">{ allocationJurisdiction.costObjectName }</div>
                    <div className="line-allocations__column_fixed-small" /> {/*reserved for count value*/}
                    <div className="line-allocations__column_fixed-small" /> {/*reserved for amount value*/}
                  </div>
                  {
                    !collapsed &&
                    <div className=" line-allocations__row line-allocations__row_long-text">
                      <div className="line-allocations__column_fixed-width">
                        { allocationJurisdiction.costObjectDescription }
                      </div>
                    </div>
                  }
                </div>
                <div className="line-allocations-jurisdiction">
                  <div className={ `line-allocations-jurisdiction__grid-container ${!allocationJurisdiction.jurisdictionItems ? " line-allocations-jurisdiction__no-jurisdiction-label" : ""} ` }>
                    {
                      !allocationJurisdiction.jurisdictionItems &&
                      <div>
                        There are no jurisdictional results to display for this cost object.
                      </div>
                    }
                    {
                      !collapsed && allocationJurisdiction.jurisdictionItems &&
                      <React.Fragment>
                        {
                          allocationJurisdiction.jurisdictionItems.map(({ jurisdictionType, jurisdiction, taxAmount, taxRate, taxable, exempt }, index) => (
                            <div className="line-allocations-jurisdiction__row" key={ `${ jurisdictionType}-${ index }` }>
                              <div className="line-allocations-jurisdiction__column">
                                <span className="allocation-jurisdiction-type">{`${ jurisdictionType }:`}</span><span>{ jurisdiction }</span>
                              </div>
                              <div className="line-allocations-jurisdiction__column_fixed-small">{ taxRate }</div>
                              <div className="line-allocations-jurisdiction__column_fixed-small">{ taxable }</div>
                              <div className="line-allocations-jurisdiction__column_fixed-small">{ exempt }</div>
                              <div className="line-allocations-jurisdiction__column_fixed-small">{ taxAmount }</div>
                            </div>
                          ))
                        }
                      </React.Fragment>
                    }
                    {
                      allocationJurisdiction.jurisdictionItems && collapsed &&
                      <div className="line-allocations-jurisdiction__row line-allocations-jurisdiction__row_bold">
                        <div className="line-allocations-jurisdiction__column">
                          <div className="allocation-jurisdiction-type">State:</div>
                          { 
                            collapsed
                              ? allocationJurisdiction.jurisdictionItems.find(jurisdiction => jurisdiction.jurisdictionType === 'State').jurisdiction 
                              : ''
                          }
                        </div>
                        <div className="line-allocations-jurisdiction__column_fixed-small line-allocations-jurisdiction__column_light">
                          { allocationJurisdiction.totalTaxRate }
                        </div>
                        <div className="line-allocations-jurisdiction__column_fixed-small line-allocations-jurisdiction__column_light">
                          Expand for Detail
                        </div>
                        <div className="line-allocations-jurisdiction__column_fixed-small line-allocations-jurisdiction__column_light">
                          Expand for Detail
                        </div>
                        <div className="line-allocations-jurisdiction__column_fixed-small line-allocations-jurisdiction__column_light">
                          { allocationJurisdiction.totalTaxAmount }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          ))
        }
        <div  className="line-allocations__container">
          <div className="line-allocations__grid-container">
            <div className="line-allocations__row">
              <div className="line-allocations__column line-allocations__column_bold">Totals</div>
              <div className="line-allocations__column_fixed-small" /> {/*reserved for total count value*/}
              <div className="line-allocations__column_fixed-small" /> {/*reserved for total amount value*/}
            </div>
          </div>
          <div className="line-allocations-jurisdiction">
            <div className="line-allocations-jurisdiction__grid-container">
              <div className="line-allocations-jurisdiction__row line-allocations-jurisdiction__row_bold">
                <div className="line-allocations-jurisdiction__column" />
                <div className="line-allocations-jurisdiction__column_fixed-small">{ totalTaxRate }</div>
                <div className="line-allocations-jurisdiction__column_fixed-small" />
                <div className="line-allocations-jurisdiction__column_fixed-small" />
                <div className="line-allocations-jurisdiction__column_fixed-small">{ totalTaxAmount }</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LineAllocation.propTypes = {
  invoiceDetail: PropTypes.object.isRequired
};

export default LineAllocation;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/c/lineAllocations/LineAllocations.js